import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useTranslation } from "react-i18next";
import { useGetAllUsedBy } from "../api/getAllUsedBy";

// All your logic is here
export const useUsedByDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetUsedBy []>([]);
  const getUsedByQuery = useGetAllUsedBy({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getUsedByQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getUsedByQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getUsedByQuery.data ? getUsedByQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Χρήση Από",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Χρήση Από");
        break;
      case "edit":
        title = t("Επεξεργασία Χρήση Από");
        break
        case "delete":
        title = t("Διαγραφή Χρήση Από");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getUsedByQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
